import User from '@/utils/user';
import { planNameByRole } from './functions';

const user = new User();

export const VIEW_TYPE_KEY = {
  months: 'months',
  weeks: 'weeks',
  days: 'days',
};

export const SEARCH_TYPE_KEY = {
  my: 0,
  moderation: 2,
  requests: 3,
};

export const SEARCH_TYPE_DATA = {
  [SEARCH_TYPE_KEY.my]: {
    id: SEARCH_TYPE_KEY.my,
    tab: {
      icon: '$iuser',
      get text() {
        if (user?.isOrganization) return 'Мой план';
        return planNameByRole();
      },
    },
    search: {
      'search[is_target_request]': 0,
    },
  },
  [SEARCH_TYPE_KEY.requests]: {
    id: SEARCH_TYPE_KEY.requests,
    tab: {
      icon: '$iuser-team',
      get text() {
        if (user?.isOrganization) return 'Ожидающие назначения';
        return 'Модерация анонсов';
      },
    },
    search: {
      'search[is_request]': 1,
    },
  },
  [SEARCH_TYPE_KEY.moderation]: {
    id: SEARCH_TYPE_KEY.moderation,
    tab: {
      icon: '$ui-user-group',
      text: 'Модерация мероприятий',
    },
  },
};

export const PLAN_INCLUSION_STATUS = {
  request: 0,
  accepted: 1,
  rejected: 2,
};

export const PLAN_INCLUSION_STATUS_DATA = {
  [PLAN_INCLUSION_STATUS.request]: {
    id: PLAN_INCLUSION_STATUS.request,
    text: 'На рассмотрении',
    icon: '$iclock-outline',
    attrs: {
      color: 'ui-warning',
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
  [PLAN_INCLUSION_STATUS.accepted]: {
    id: PLAN_INCLUSION_STATUS.accepted,
    text: 'Принято',
    icon: '$icheck-outline-circle',
    attrs: {
      color: 'ui-success',
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
  [PLAN_INCLUSION_STATUS.rejected]: {
    id: PLAN_INCLUSION_STATUS.rejected,
    text: 'Отменено',
    icon: '$ialert',
    attrs: {
      color: 'ui-error',
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
};

export const PLAN_INCLUSION_TYPE = {
  organizers: 'organizers',
  municipalities: 'municipalities',
  regions: 'regions',
  event_associations: 'event_associations',
};

/**
 * @userField - это ссылка на поле внутри нашего юзера (utils/user), в котором есть интересующие нас данные
 * @requestField - это поле, которые отправляем при создании/принятии/отклонении/удалении запроса на вхождение в план
 */
export const PLAN_INCLUSION_TYPE_DATA = {
  [PLAN_INCLUSION_TYPE.organizers]: {
    id: PLAN_INCLUSION_TYPE.organizers,
    text: 'Организация',
    userField: 'organizer',
    requestField: 'organizer_id',
  },
  [PLAN_INCLUSION_TYPE.municipalities]: {
    id: PLAN_INCLUSION_TYPE.municipalities,
    text: 'Муниципалитет',
    userField: 'department',
    requestField: 'municipality_id',
  },
  [PLAN_INCLUSION_TYPE.regions]: {
    id: PLAN_INCLUSION_TYPE.regions,
    text: 'Регион',
    userField: 'region',
    requestField: 'region_id',
  },
  [PLAN_INCLUSION_TYPE.event_associations]: {
    id: PLAN_INCLUSION_TYPE.event_associations,
    text: 'Ассоциация',
    userField: 'organizer',
    requestField: 'event_association_id',
  },
};
